module.exports = __webpack_public_path__ + "assets/task-text.f09de8c3.svg";